import styled from '@emotion/styled';
import { colors, fonts, layout } from './theme';

const Root = styled.section`
  background: ${colors.baselineBlue};
  padding: clamp(56px, 8vw, 96px) 0;
`;

const Inner = styled.div`
  max-width: ${layout.maxWidth};
  margin: 0 auto;
  padding: 0 clamp(20px, 4vw, 32px);
  scroll-margin-top: 90px;
`;

const Eyebrow = styled.p`
  font-family: ${fonts.mono};
  font-size: 13px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: ${colors.textMuted};
  margin: 0 0 16px;
`;

const Headline = styled.h2`
  font-family: ${fonts.sans};
  font-size: clamp(32px, 3.8vw, 48px);
  line-height: 1.15;
  max-width: 24ch;
  font-weight: 400;
  color: ${colors.coreBlue};
  margin: 0 0 16px;
`;

const Subcopy = styled.p`
  font-family: ${fonts.sans};
  font-size: 19px;
  line-height: 1.5;
  color: ${colors.textSecondary};
  max-width: 62ch;
  margin: 0 0 40px;
`;

const StatGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
  margin-bottom: 32px;

  @media (min-width: 800px) {
    grid-template-columns: repeat(3, 1fr);
  }
`;

const StatCard = styled.div<{ dark?: boolean }>`
  background: ${({ dark }) => (dark ? colors.coreBlue : colors.baselineWhite)};
  border-radius: 8px;
  padding: 24px;
`;

const StatValue = styled.p<{ dark?: boolean }>`
  font-family: ${fonts.sans};
  font-size: 64px;
  line-height: 1.1;
  letter-spacing: -0.02em;
  font-weight: 400;
  margin: 0 0 8px;
  color: ${({ dark }) => (dark ? colors.baselineWhite : colors.coreBlue)};
`;

const StatLabel = styled.p<{ dark?: boolean }>`
  font-family: ${fonts.mono};
  font-size: 12px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  margin: 0;
  color: ${({ dark }) => (dark ? 'rgba(255, 255, 255, 0.78)' : colors.textMuted)};
`;

const Tags = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
`;

const Tag = styled.span`
  font-family: ${fonts.mono};
  font-size: 12px;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: ${colors.coreBlue};
  border: 1px solid ${colors.borderDefault};
  border-radius: 4px;
  padding: 8px 14px;
`;

const STATS = [
  { value: '50', label: 'Publisher placements analysed every second', dark: false },
  { value: '7', label: 'Behavioural and contextual dimensions per relevance score', dark: false },
  { value: '1-100', label: 'Relevance score, adapting to the campaign KPI in flight', dark: true },
];

const TAGS = [
  'DIRECT TOPIC CONTEXT',
  'BEHAVIOURAL ALIGNMENT',
  'AUDIENCE PROBABILITY',
  'NARRATIVE SIMILARITY',
  'CULTURAL IDENTITY',
  'AUTHORITY TRUST',
  'CONTEXT CONVENIENCE',
];

export default function ContextualEngineSection() {
  return (
    <Root>
      <Inner id="contextual-engine">
        <Eyebrow>Contextual Engine</Eyebrow>
        <Headline>contextual intelligence for publishers</Headline>
        <Subcopy>
          A creative and brief becomes an entire end-to-end video marketing campaign in one
          workflow.
        </Subcopy>
        <StatGrid>
          {STATS.map((stat) => (
            <StatCard key={stat.label} dark={stat.dark}>
              <StatValue dark={stat.dark}>{stat.value}</StatValue>
              <StatLabel dark={stat.dark}>{stat.label}</StatLabel>
            </StatCard>
          ))}
        </StatGrid>
        <Tags>
          {TAGS.map((tag) => (
            <Tag key={tag}>{tag}</Tag>
          ))}
        </Tags>
      </Inner>
    </Root>
  );
}
